export default __webpack_public_path__ + "static/media/VG_logo_long.7c80bd1a.png";